module.exports = __webpack_public_path__ + "img/1164367616.fe6a06ca.jpg";